import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
//import Spinner from 'react-spinkit';
import {injectIntl} from 'react-intl';
// import { HTTP_STATUS } from 'util/constants';
//import { HTTP_STATUS } from 'modules/api';

import { loginRecover, cleanErrors } from 'modules/auth';

import RecoverPasswordForm from 'components/login/RecoverPasswordForm';

/** Redux container for the login password container form */
class RecoverPasswordFormContainer extends Component {
    static propTypes = {
        auth:     PropTypes.object, //The auth object
        valid:    PropTypes.bool, //Keycode is valid?
        errorMsg: PropTypes.string//The error message that it is sent from RecoverPassword.jsx
    };

    state = {
        recoverSuccess: false, // If the recovering was seccesfuly
        inputError:     {
            message: '' // The error message of the input
        }
    };

    componentWillMount() {
        //const {recoverKey} = this.props;
        this.handleSubmit = this.handleSubmit.bind(this);
        //this.verifyRecoverKey(recoverKey);
    }

    componentWillUnmount() {
        const { dispatch } = this.props;

        dispatch(cleanErrors());
    }

    /**
     * Renders the spinner if the server is verifying the key.
     */
    /*renderVerifyingKey() {
    //Esto se ha comentado porque se ha eliminado la logica para agregar una verificacion de key al comienzo del
    //login y no mostrarle los input fields a todos, sino solamente a los que tengan el key correcto
        const {intl: {formatMessage}} = this.props;

        return (
            <div className="recover-spinner">
                <Spinner key="login-spinner" name="circle" className="login-spinner recover" fadeIn="none" />
                <div key="login-spinner-text" className="login-spinner-text">{formatMessage({id: 'spinner.loading'})}
                </div>
            </div>);
    }*/

    /*verifyRecoverKey(recoverKey) {
        const {dispatch, intl: {formatMessage}} = this.props;

        const invalidMsg = formatMessage({id: 'login.token_invalid'});
        const badRequest = formatMessage({id: 'login.bad_request'});

        dispatch(loginKeyRecover(recoverKey))
            .then(() => {
                this.setState({
                    recoverSuccess: false,
                    valid:          true,
                    inputError:     {
                        message: ''
                    }
                });
            })
            .catch(responseError => {
                if (responseError.response && responseError.response.status === HTTP_STATUS.HTTP_STATUS_NOTFOUND) {
                    this.setState({
                        inputError: {
                            message: invalidMsg
                        },
                        recoverSuccess: false,
                        valid:          false
                    });
                } else {
                    this.setState({
                        inputError: {
                            message: badRequest
                        },
                        recoverSuccess: false,
                        valid:          false
                    });
                }
            });
    }*/

    /**
     *
     */
    componentWillReceiveProps(nextProps) {
        const {auth} = nextProps;
        const nextRecoverKey = nextProps.recoverKey;
        const {auth: {recoverSuccess, error}, recoverKey} = this.props;
        const result = {};

        if (recoverSuccess !== auth.recoverSuccess) {
            result.recoverSuccess = auth.recoverSuccess;
            result.inputError = {
                message: ''
            };
        } else if (auth.error && error !== auth.error) {
            result.inputError = auth.error;
        } else if (recoverKey !== nextRecoverKey) {
            this.verifyRecoverKey(nextRecoverKey);
        }

        if (Object.keys(result).length) {
            this.setState(result);
        }
    }

    handleSubmit(password, passwordConfirm) {
        const { dispatch, recoverKey, uid, intl: {formatMessage}} = this.props;
        let invalidMsg = formatMessage({id: 'login.empty_password'});

        if (password && passwordConfirm && password === passwordConfirm) {
            dispatch(loginRecover(password, passwordConfirm, recoverKey, uid));
        } else {
            if (passwordConfirm && password) {
                invalidMsg = formatMessage({id: 'login.invalid_password'});
            }
            this.setState({
                recoverSuccess: false,
                inputError:     invalidMsg
            });
        }

    }

    render() {
        const { auth:{isResetting, recoverError}} = this.props;
        const {recoverSuccess, inputError} = this.state;

        let errorMessage = recoverError || inputError;

        errorMessage = typeof errorMessage === 'string' ? errorMessage : errorMessage && errorMessage.message;

        return (
            <RecoverPasswordForm
                onSubmit={this.handleSubmit}
                isResetting={isResetting}
                recoverError={errorMessage}
                recoverSuccess={recoverSuccess}
                validKey={true}
            />
        );
    }
}

const mapStateToProps = state => ({
    auth:    state.auth,
    routing: state.routing
});

export default injectIntl(connect(mapStateToProps)(RecoverPasswordFormContainer));



// WEBPACK FOOTER //
// ./src/containers/login/RecoverPasswordFormContainer.jsx